import Backbone from "backbone";
import * as Mustache from "mustache";

import readlangClient from "readlangClient";

// model - RemoteUserWords
const UndoDeleteView = Backbone.View.extend({
  initialize: function () {
    const that = this;

    this.listenTo(this.model, "wordsDeleted", (options) => {
      that.deletedDate = options.deletedDate;
      that.numDeleted = options.numDeleted;
      that.render();
    });
    this.listenTo(this.model.selectionModel, "change:count", () => {
      that.$el.hide();
    });
    this.listenTo(this.model.searchQuery, "change", () => {
      that.$el.hide();
    });
  },
  render: function () {
    const template =
      '{{numDeleted}} words deleted. <a href="#" class="undoDelete">Undo</a>';
    this.$el.html(Mustache.render(template, this)).show();
  },
  events: {
    "click a.undoDelete": "undoDelete",
  },
  undoDelete: function (event) {
    const that = this;
    event.preventDefault();
    event.stopPropagation();

    this.$el.hide();

    readlangClient.request(
      "PATCH",
      "/api/userWords/unDelete",
      { deletedDate: this.deletedDate },
      () => {
        that.model.reFetch();
      }
    );
  },
});

export default UndoDeleteView;
